import symbollImg from "./images/symboll.png";
import webzImg from "./images/webz.png";

export const projectsTmp = [
  {
    id: "1",
    name: "XM Cyber",
    description: "Ongoing maintenance",
    img: "/xm.png",
    link: "https://xmcyber.com/",
  },
  {
    id: "3",
    name: "Webz",
    description: "Ongoing maintenance",
    img: webzImg,
    link: "https://webz.io/",
  },
  {
    id: "2",
    name: "Symboll",
    description: "Website rebuild",
    img: symbollImg,
    link: "https://symboll.com/",
  },
];

export const aboutData = {
  Danny:
    "Daniel, the founder of Bubble, is an entrepreneur whose career spans more than a decade in web development, management, and consulting. What sets Daniel apart is his unparalleled communication skills and creativity. He founded Bubble in 2022 to give support to his clients, empowering them while doing what he loves.",
  name: "Daniel Blank",
  x: "https://x.com/daniel_a_blank",
  linkedin: "https://www.linkedin.com/company/bubble-m87tech",
  mail: "db@m87technologies.com",
};

export const testimonialsData = [
  {
    id: 1,
    name: "Keren Farin",
    title: "XM Cyber",
    company: "XM Cyber",
    text: "Bubble feels like having a smart and reliable partner on standby. There's always someone available who knows our site and keeps everything moving.",
  },
  {
    id: 2,
    name: "Steve Burg",
    title: "Webz",
    company: "Webz",
    text: "Working with Bubble means we're never stuck or waiting. There's always a knowledgeable person available who takes ownership and moves things forward.",
  },
];

// Maintenance care plans - transparent tiers. Pricing intentionally omitted
// until real numbers are set; CTA routes to a call instead.
export const carePlans = [
  {
    id: "essential",
    name: "Essential",
    tagline: "Keep the lights on, securely.",
    hours: "5",
    featured: false,
    features: [
      "Security & CMS patching",
      "Uptime monitoring + SLA",
      "Core Web Vitals performance checks",
      "SEO health monitoring",
      "Standard response time",
    ],
  },
  {
    id: "growth",
    name: "Growth",
    tagline: "For teams shipping and announcing often.",
    hours: "25",
    featured: true,
    features: [
      "Everything in Essential",
      "AI-answer (GEO) visibility checks",
      "Conversion tracking",
      "Priority during launches",
      "Next-day response time",
    ],
  },
  {
    id: "partner",
    name: "Partner",
    tagline: "We're an extension of your team.",
    hours: "50",
    featured: false,
    features: [
      "Everything in Growth",
      "Ongoing conversion optimization (CRO)",
      "Weekly search + AI-visibility review",
      "Direct line to your maintainer",
      "Same-day response time",
    ],
  },
];
